import { createStore } from 'vuex'
import popup from './states/popup'

export default createStore({
    modules: {
        popup: popup,
    }
})

